(() => {
  if (customElements.get('zaoud-pos-selector')) return;

  class ZaoudPosSelector extends HTMLElement {
    constructor() {
      super();
      this.selectedItems = new Map();
    }

    connectedCallback() {
      this.accordionContainer = this.querySelector('[data-accordion-container]');
      this.setupAccordion();
      this.setupVariantChange();
      this.setupCheckboxes();
      this.setupQuantityChange();
      this.renderSelectedItems();
    }

    setupAccordion() {
      const headers = this.querySelectorAll('[data-accordion-header]');
      const items = this.querySelectorAll('[data-accordion-item]');

      headers.forEach((header) => {
        header.addEventListener('click', () => {
          const currentItem = header.closest('[data-accordion-item]');
          const isOpen = currentItem.classList.contains('is-open');

          items.forEach((item) => item.classList.remove('is-open'));

          if (!isOpen) {
            currentItem.classList.add('is-open');

            if (this.accordionContainer) {
              window.setTimeout(() => {
                const relativePosition = currentItem.offsetTop - this.accordionContainer.offsetTop;
                this.accordionContainer.scrollTo({
                  top: relativePosition,
                  behavior: 'smooth',
                });
              }, 50);
            }
          }
        });
      });
    }

    setupVariantChange() {
      this.querySelectorAll('[data-variant-radio]').forEach((radio) => {
        radio.addEventListener('change', (event) => {
          const row = event.target.closest('[data-product-row]');
          const priceElement = row.querySelector('[data-price]');
          priceElement.textContent = this.formatMoney(event.target.dataset.variantPrice);

          const productId = row.dataset.productId;
          if (this.selectedItems.has(productId)) {
            this.updateSelectedItem(row);
          }
        });
      });
    }

    setupQuantityChange() {
      this.querySelectorAll('[data-quantity]').forEach((input) => {
        input.addEventListener('change', (event) => {
          const row = event.target.closest('[data-product-row]');
          const productId = row.dataset.productId;

          if (this.selectedItems.has(productId)) {
            this.updateSelectedItem(row);
          }
        });
      });
    }

    setupCheckboxes() {
      this.querySelectorAll('[data-select-checkbox]').forEach((checkbox) => {
        checkbox.addEventListener('change', (event) => {
          const row = event.target.closest('[data-product-row]');
          const productId = row.dataset.productId;

          if (event.target.checked) {
            this.addSelectedItem(row);
          } else {
            this.removeSelectedItem(productId);
          }
        });
      });
    }

    addSelectedItem(row) {
      const productId = row.dataset.productId;
      const productTitle = row.querySelector('[data-select-checkbox]').dataset.productTitle;
      const selectedVariant = row.querySelector('[data-variant-radio]:checked');
      const variantTitle = selectedVariant.dataset.variantTitle;
      const variantPrice = selectedVariant.dataset.variantPrice;
      const quantity = row.querySelector('[data-quantity]').value;

      this.selectedItems.set(productId, {
        productId,
        productTitle,
        variantTitle,
        variantPrice,
        quantity,
        row,
      });

      this.renderSelectedItems();
    }

    updateSelectedItem(row) {
      const productId = row.dataset.productId;
      if (this.selectedItems.has(productId)) {
        this.addSelectedItem(row);
      }
    }

    removeSelectedItem(productId) {
      this.selectedItems.delete(productId);

      const checkbox = this.querySelector(
        `[data-product-row][data-product-id="${productId}"] [data-select-checkbox]`
      );

      if (checkbox) {
        checkbox.checked = false;
      }

      this.renderSelectedItems();
    }

    calculateTotal() {
      let total = 0;

      this.selectedItems.forEach((item) => {
        total += parseFloat(item.variantPrice) * parseInt(item.quantity, 10);
      });

      return total;
    }

    renderSelectedItems() {
      const listContainer = this.querySelector('[data-selected-list]');
      const totalSection = this.querySelector('[data-total-section]');
      const totalAmount = this.querySelector('[data-total-amount]');

      if (!listContainer) return;

      if (this.selectedItems.size === 0) {
        listContainer.innerHTML = '<div class="zaoud-pos__empty">No items selected</div>';
        totalSection?.classList.remove('is-visible');
        return;
      }

      listContainer.innerHTML = '';

      this.selectedItems.forEach((item, productId) => {
        const itemElement = document.createElement('div');
        itemElement.className = 'zaoud-pos__selected-item';
        itemElement.innerHTML = `
          <div class="zaoud-pos__selected-item-info">
            <div class="zaoud-pos__selected-item-name">${item.productTitle}</div>
            <div class="zaoud-pos__selected-item-variant">Variant: ${item.variantTitle}</div>
            <div class="zaoud-pos__selected-item-variant">Quantity: ${item.quantity}</div>
            <div class="zaoud-pos__selected-item-price">${this.formatMoney(item.variantPrice)}</div>
          </div>
          <button type="button" class="zaoud-pos__remove-btn" data-remove="${productId}" aria-label="Remove item">&times;</button>
        `;

        itemElement.querySelector('[data-remove]').addEventListener('click', () => {
          this.removeSelectedItem(productId);
        });

        listContainer.appendChild(itemElement);
      });

      if (totalAmount) {
        totalAmount.textContent = this.formatMoney(this.calculateTotal());
      }

      totalSection?.classList.add('is-visible');
    }

    formatMoney(cents) {
      const amount = parseFloat(cents) / 100;
      const currency = this.dataset.currency || 'EUR';
      const locale = this.dataset.locale || 'it-IT';

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(amount);
    }
  }

  customElements.define('zaoud-pos-selector', ZaoudPosSelector);
})();
